<template>
  <div class="file">
    <div class="file-view">
      <v-row no-gutters class="mt-3">
        <v-col v-if="item.fileType !== 'EXCEL_MINKULT' && item.fileType !== 'EXCEL_FOUNDER_FILE'" :cols="cols">
          <div class="file-view__name">
            <img src="@/assets/icons/file-outline.svg" alt=""/>
            <div class="file-view__name-info">
              <div class="font-weight-600">{{ item.name }}</div>
              <div class="d-flex flex-row align-center">
                <span v-if="item[id] && uploadFileDate" class="mr-3"> Дата загрузки: {{ uploadFileDate }}</span>
                <div class="file-view__date ">
                  <div v-if="item[id]">
                    <span @click="getFile" class="file-link mr-4">
                <v-progress-circular
                  v-if="downloadingFile"
                  indeterminate
                  color="primary"
                  size="14"
                  width="2"
                ></v-progress-circular>
                      {{ item.fileNameOrig ? item.fileNameOrig : 'Загруженный файл' }}</span>
                  </div>
                  <div v-else class="error--text ">
                    <slot name="emptyFile">Не загружено</slot>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="2">
          <div class="file-view__actions d-flex flex-row align-center">
            <div
              class="d-flex flex-column align-end"
              v-if="!(item.fileType === 'KONVERT' && item.fileNameOrig)"
            >
              <v-btn
                class="white__v-btn"
                :disabled="disabled"
                @click="modeEdit = !modeEdit"
              >
                Загрузить
              </v-btn>
            </div>
            <div class="d-flex flex-column align-center">
              <slot name="deleteBtn" :deleteFile="deleteFile">
                <v-btn
                  v-if="canDelete"
                  icon
                  :disabled="disabled"
                  @click="deleteFile()"
                >
                  <v-icon color="error">mdi-delete-outline</v-icon>
                </v-btn>
                <v-btn
                  v-else-if="customDeleteTypes.includes(item.fileType) && item.id"
                  class="error__v-btn ml-3"
                  :disabled="disabled"
                  @click="deleteFile()"
                >
                  Удалить
                </v-btn>
              </slot>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="modeEdit && !disabled" no-gutters>
        <v-col>
          <v-file-input
            clearable
            label="Выбрать файл..."
            v-model="fileToUpload"
            :accept="typesFiles"
            :error="error"
            :error-messages="errorMessage"
            :disabled="disabled || uploadToServNow"
            :loading="uploadToServNow"
            prepend-icon=""
            :rules="rules"
            @change="errUpd($event)"
          />
        </v-col>
        <v-col cols="2" class="d-flex flex-row align-center justify-end">
          <div class="d-flex flex-column align-end">
          </div>
          <div class="d-flex flex-column align-center">
            <v-btn
              icon
              :disabled="!canUpload || uploadToServNow"
              @click="clearForm"
            >
              <v-icon color="error">mdi-close-circle-outline</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "scanCard",
  props: {
    item: {
      type: Object,
      default: () => ({
        types: [],
        typesForChose: [],
        name: '',
        id: null,
        uploadDate: ''
      })
    },
    disabled: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    uploadToServNow: {
      type: Boolean,
      default: false
    },
    downloadingFile: {
      type: Boolean,
      default: false
    },
    token: {
      type: String,
      default: ''
    },
    cols: {
      type: Number,
      default: 4
    },
    // currentStage: {
    //   type: Number,
    //   default: 0
    // },
    fileSize: {
      type: [String, Number],
      default: 20000000
    },
    id: {
      type: String,
      default: 'id'
    },
    identifier: {
      type: String,
      default: 'fileType'
    }
  },
  data() {
    return {
      fileToUpload: null,
      modeEdit: false,
      uploadNow: false,
      error: false,
      errorMessage: '',
      rules: [
        value => value != null || 'Выберите файл',
        value => !value || this.item.types.includes(value.type) || 'Недопустимый формат файла',
        value => value?.size < this.maxFilesSize || `Размер файла не должен превышать ${this.maxFilesSize / 1000000} МБ!`,
      ],
      customDeleteTypes: ['USTAV_MAIN_ORG', 'PRIKAZ_MAIN_ORG', 'KONVERT'],
      canUpload: true,
    }
  },
  computed: {
    ...mapGetters('checkFilled', {currentStage: 'currentStage', organizationSendKonvert: 'organizationSendKonvert',}),
    ...mapGetters('keycloak', {getAuthData: 'getAuthData', getKeycloakData: 'getKeycloakData', userId: 'userId'}),
    uploadFileDate() {
      return this.item?.uploadDate?.slice(0, 10) ?? ''
    },
    maxFilesSize() {
      return Number.parseInt(this.fileSize)
    },
    typesFiles() {
      if (this.item.typesForChose && this.item.typesForChose === 'all' || this.item.typesForChose?.length === 0 || this.item.typesForChose?.includes('all'))
        return null
      return this.item?.typesForChose?.join(',') ?? null
    },
  },
  methods: {
    errUpd(evt) {
      if (evt && evt.size < this.maxFilesSize) {
        this.error = false;
        this.errorMessage = '';
        this.uploadFile()
      }
    },
    clearForm() {
      this.modeEdit = false;
      this.fileToUpload = null;
      this.canUpload = true;
      this.error = false;
      this.errorMessage = '';
    },
    uploadFile() {
      if (this.fileToUpload?.size < this.maxFilesSize && (this.item.types.length > 0 && this.item.types.includes(this.fileToUpload.type) || this.item.types.length === 0)) {
        this.error = false;
        this.errorMessage = '';
        if (this.fileToUpload) {
          if (this.item[this.id]) {
            this.$emit('replace-file', {
              [this.identifier]: this.item[this.identifier],
              'file': this.fileToUpload,
              'id': this.item[this.id]
            });
          } else {
            this.$emit('upload-file', {[this.identifier]: this.item[this.identifier], 'file': this.fileToUpload});
          }
        }
      } else {
        this.canUpload = false
        this.error = true;
        for (const check of this.rules) {
          if (typeof check(this.fileToUpload) === 'string') {
            this.errorMessage = check(this.fileToUpload);
            break;
          }
        }
      }
    },
    async deleteFile() {
      if (this.item[this.id]) {
        this.$emit('delete-file', {
          [this.identifier]: this.item[this.identifier],
          'file': this.fileToUpload,
          'id': this.item[this.id]
        });
        this.modeEdit = false;
        this.fileToUpload = null;
      } else {
        this.fileToUpload = null;
      }
    },
    async getFile() {
      this.uploadNow = true;
      try {
        this.$emit('get-file', {id: this.item[this.id], [this.identifier]: this.item[this.identifier],})
      } catch (e) {
        this.uploadNow = false;
        console.log("e", e)
      }
    }
  },
}
</script>

<style scoped>

</style>